import { useQuery } from "@tanstack/react-query"
import { getAsientoContableModelo347 } from "api/AsientoContable.service"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "../../../../../../routes/RoutePaths"
import { HandleTabs } from "../../DetalleImpuestos"
import ModeloAnual from "../ModeloAnual"
import { RedirectParams } from "../constants"

export const Modelo347 = ({
  props: { year, handleYearSelection, yearsOptionList },
}: {
  props: HandleTabs
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigate = ({ route, periodo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      year,
    })
  }

  const fetchModelo347 = async () => {
    const data = await getAsientoContableModelo347({
      Anyo: year.selectedYear,
    })
    return data
  }

  const { data, isLoading } = useQuery({
    queryKey: ["modelo347", year.selectedYear],
    queryFn: fetchModelo347,
    select: (data) => {
      if (!data) return
      return [
        {
          text: t("taxSummary.table347TextOne"),
          value: data.totalPersonasEntidades,
          currencyFormat: false,
        },
        {
          text: t("taxSummary.table347TextTwo"),
          value: data.totalOperaciones,
          currencyFormat: true,
        },
        {
          text: t("taxSummary.table347TextThree"),
          value: data.totalInmuebles,
          currencyFormat: false,
        },
        {
          text: t("taxSummary.table347TextFour"),
          value: data.totalOperacionesArrendamientoLocalesNegocio,
          currencyFormat: true,
        },
      ]
    },
  })

  return (
    <ModeloAnual
      t={t}
      year={year}
      handleYearSelection={handleYearSelection}
      yearsOptionList={yearsOptionList}
      navigateDeclaracion={() =>
        navigate({
          route: `${ROUTES.DECLARACION_MODELO_347}`,
          year: year.selectedYear,
        })
      }
      navigate={() =>
        navigate({
          route: `${ROUTES.RESUMEN_IMPUESTOS_DETAIL_347}`,
          modelo: MODELO_IMPUESTO.MODELO_347,
          year: year.selectedYear,
        })
      }
      isLoading={isLoading}
      data={data}
      isModelo347
    />
  )
}
